import { Button, Container, RadioGroup, FormControlLabel, Radio, Typography, Grid, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useEffect, useState } from 'react';
import * as azblob from '@azure/storage-blob';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const DigiTienerToneelForm = (props) => {

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }
        else {
            setInskrywingInfo({ ...inskrywing, "inskrywerId":props.userProf.userProfile.id })
        }

    }, [])

    const classes = useStyles();
    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [vid, setVid] = useState("GEEN");
    const [vidOpgelaai, setVidOpgelaai] = useState(false);
    const [teks, setTeks] = useState("");
    const [teksOpgelaai, setTeksOpgelaai] = useState(false);
    const [formIsInValid, setFormIsInvalid] = useState(true);
    const [isBemagtig, setIsBemagtig] = useState(true);
    const [inskrywing, setInskrywingInfo] = useState({
        "inskrywerId": "",
        "ouerNaamVan":"",
        "onderwerp": "",
        "kunsmedium": "",
        "gedigOorsprong":"",
        "ouerBemagtigingGegee": false,
        "vidGelaai": false,
        "teksGelaai": false
    });
    const [inskrywingId, setInskrywingId] = useState();


    const accountName = "projektestorage";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    const containerName = "digitienertoneel";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    //const fileList = document.getElementById("file-list");
    const fileInput = document.getElementById("vid-input");
    const teksInput = document.getElementById("teks-input");


    const style = {

        padding: "20px",
    }


    const formChange = (e) =>
    {
        if (e.target.type === "radio") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.value });
        }
        else if (e.target.type === "checkbox") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.checked });

        }
        else {
            setInskrywingInfo({ ...inskrywing, [e.target.id]: e.target.value });
        }
    }

    const finishRegistration = async () => {
            //start upload ui
            setIsUploading(true);
            //insert record for inskrywing into db
           fetch('api/UserEntries/tienertoneel/new', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
               },
               body: JSON.stringify(inskrywing)
            })
                .then((response) => response.json())
               .then((data) => {
                   setInskrywingId(data.id);
                   //console.log('data logged as reposne', data);
               })

        }

    const uploadVidToBlob = async () => {
        //await finishSubmit();
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of fileInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.ouerNaamVan + "-" + inskrywing.inskrywerId + "-inskrywing-video-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        for (const textfile of teksInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.ouerNaamVan + "-" + inskrywing.inskrywerId + "-inskrywing-teks-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, textfile, blockBlobURL));

        }
        await Promise.all(promises);
        reportStatus("Sukses!");
        setIsUploading(false);
        window.setTimeout(props.history.push('suksesinskryf'), 500);
    }


    const vidInputChanged = () => {
        if (document.getElementById("vid-input").value != "") {
            setVid("Videomateriaal gekies!");
            setVidOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": true })
        }
        else {
            setVid("");
            setVidOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": false })


        }

    }

    const teksInputChange = () =>
    {
        if (document.getElementById("teks-input").value != "") {
            setTeks("Teks gekies!");
            setTeksOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "teksGelaai": true })
        }
        else {
            setTeks("");
            setTeksOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "teksGelaai": false })


        }

    }
    //unneccessary for production
    useEffect(() => {
        //console.log('loigging props on digipraatform', props);
        console.log('logging inskrywing state', inskrywing);
    }, [])

    useEffect(() =>
    {
        if (inskrywingId !== undefined) {
            //wait for id to be returned before uploading video to azureblob
            //window.alert('BEGIN VIDEOMATERIAAL LAAI, ASSEBLIEF WEES GEDULDIG');
            uploadVidToBlob();
        }
    }, [inskrywingId])


    useEffect(() =>
    {
        //as inskrywing verander, kyk of vorm leeg is

        //console.log('Inskrywing:', inskrywing);
        var isValid = true;

        for (var property in inskrywing) {
            if (property === "ouerBemagtigingGegee") {
                if (inskrywing["ouerBemagtigingGegee"] === false) {
                    isValid = false;
                }
            }
            else if (property === "teksGelaai") {
                if (inskrywing["teksGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (property === "vidGelaai") {
                if (inskrywing["vidGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (inskrywing[property] === "") {
                isValid = false;
            }
            //console.log(`key= ${property} value = ${inskrywing[property]}`)
        }
        if (isValid) {
            setFormIsInvalid(false);
        }
        else {
            setFormIsInvalid(true);
        }


    }, [inskrywing])


    return (
        <Container className="container" style={style}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Deelnemerbesonderhede</Typography>

                    <TextField onChange={formChange} id="ouerNaamVan" required label="Naam en van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="onderwerp" label="Monoloog-titel" variant="outlined" margin="normal"  fullWidth />

                    <TextField onChange={formChange} id="kunsmedium" label="Tema van monoloog" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="gedigOorsprong" label="Skrywer van monoloog" variant="outlined" margin="normal"  fullWidth />

                    <Typography variant="h5" gutterBottom>Ouermagtiging</Typography>
                    <Grid container>
                        <Grid item xs={2} lg={2}>
                            <Checkbox
                                onChange={formChange}
                                color="primary"
                                name="ouerBemagtigingGegee"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={10} lg={10}>
                            <Typography variant="h6" gutterBottom>
                                {
                                    //important notice to be ticked
                                }
                                    Hiermee gee ek toestemming dat my kind aan ATKV-Tienertoneel mag deelneem. Ek gee toestemming dat my videomateriaal op enige sosialemediaplatform van die ATKV geplaas mag word.                        </Typography>
                        </Grid>
                    </Grid>


                </Grid>
                <Grid item xs={12} sm={6} lg={6}>
                    <div className={classes.root}>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Laai videomateriaal
  <input
                                id="vid-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={vidInputChanged}
                                accept="video/*"

                            />
                        </Button>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Laai teks
  <input
                                id="teks-input"
                                type="file"
                                accept="text/*, .docx, .pdf, .txt"
                                style={{ display: "none" }}
                                onChange={teksInputChange}

                            />
                        </Button>
                        {vidOpgelaai ? <p> {vid} </p> : <p> </p>}
                        {teksOpgelaai ? <p> {teks} </p>: <p> </p>}
                    </div>
                </Grid>
                <Grid container justify="center">
                    {isUploading ? <Grid item> <CircularProgress /> <Typography variant="body1" gutterBottom>{status}</Typography> </Grid> : <br />}
                </Grid>

                <Grid container justify="center">
                    <Grid>
                        <Button variant="contained" size="large" color="primary" disabled={formIsInValid} onClick={finishRegistration}>Voltooi my inskrywing</Button>

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )

}


export default DigiTienerToneelForm;


// WEBPACK FOOTER //
// ./src/components/inskrywingsvorms/DigiTienerToneelForm.js